import { serverDate } from '@/lib/time/serverClock';

export const UPGRADE_WINDOW_DAYS = 5;
const UPGRADE_WINDOW_MS = UPGRADE_WINDOW_DAYS * 24 * 60 * 60 * 1000;

// ISO string for the moment the upgrade window closes – endDate + 5 days.
// Returns null when the event has no end_date (window never closes).
export function getUpgradeDeadline(endDate: string | null | undefined): string | null {
  if (!endDate) return null;
  const end = new Date(endDate).getTime();
  if (Number.isNaN(end)) return null;
  return new Date(end + UPGRADE_WINDOW_MS).toISOString();
}

// `now` defaults to the server's clock (src/lib/time/serverClock.ts).
// Whether a participant may still upgrade their ticket for certificate access.
// Open before the event ends and for UPGRADE_WINDOW_DAYS afterwards; closed
// after that. Events with no end_date never close.
export function isWithinUpgradeWindow(
  endDate: string | null | undefined,
  now: Date = serverDate(),
): boolean {
  if (!endDate) return true;
  const end = new Date(endDate).getTime();
  if (Number.isNaN(end)) return true;
  return now.getTime() < end + UPGRADE_WINDOW_MS;
}
